import withAsyncRouteLoading from "UIComponents/AsyncRouteLoadingHoc";
import UnitPlanDetails from "UnitPlanDetails/index.v2";
export default store => {
  return {
    path: "units-section",
    component: withAsyncRouteLoading(
      () =>
        Promise.all([
          import(/* webpackChunkName: "toddle-library" */ "./components"),
        ]).then(([importedModule0]) => {
          const component = importedModule0.default;
          return component;
        })
      // .catch(err => {
      //   throw err;
      // })
    ),
    childRoutes: [UnitPlanDetails(store)],
  };
};
